import shortid from 'shortid';
import { uniq } from 'lodash';
import authClient from './authClient';
import { Device, Devices } from './models';
import { CustomAttributes } from './authClient/constants';

type SaveDeviceRequest = {
  type: Device['type'];
};

const normalizeDevices = (devices: Devices) => devices.map<Device>(({ id, created, type }) => ({ id, created, type }));

export default {
  async saveDevices(devices: Devices): Promise<Devices> {
    const deviceUpdates = JSON.stringify(normalizeDevices(devices));
    await authClient.updateUserAttributes({ [CustomAttributes.HomeDevices]: deviceUpdates });
    return JSON.parse(deviceUpdates);
  },

  async saveDevice(devices: Devices, device: SaveDeviceRequest): Promise<Devices> {
    const toSave = {
      ...device,
      id: shortid(),
      created: Date.now(),
    };
    return await this.saveDevices([toSave, ...devices]);
  },

  async deleteDevice(devices: Devices, deviceId: string): Promise<Devices> {
    const toSave = devices.filter(({ id }) => id !== deviceId);
    if (toSave.length !== devices.length) {
      return await this.saveDevices(toSave);
    }
    return devices;
  },

  async saveTestGroups(testGroups: Array<string>): Promise<void> {
    const tg = uniq(testGroups);
  
    return authClient.updateUserAttributes({ [CustomAttributes.TestGroups]: JSON.stringify(tg) });
  }
};



// WEBPACK FOOTER //
// ./packages/smart-home-support/api/userClient.ts